import { motion } from "framer-motion";

/**
 * Kinetic hero heading — reveal via framer-motion transform only.
 * Text always renders fully visible; motion adds a Y-rise on load.
 */
export default function KineticHeading({
  lines = [],
  className = "",
  lineClassName = "",
  delay = 0.05,
}) {
  return (
    <h1 className={className} data-testid="kinetic-heading">
      {lines.map((line, i) => (
        <span key={i} className="line-mask">
          <motion.span
            className={`line-inner ${lineClassName}`}
            initial={{ y: "40%" }}
            animate={{ y: "0%" }}
            transition={{
              duration: 1.0,
              ease: [0.7, 0, 0.2, 1],
              delay: delay + i * 0.13,
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </h1>
  );
}
